<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPexipLogo_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3 18.675V21h4.8V2.4H3v2.325h2.541v13.95H3Zm18-13.95V2.4h-4.8V21H21v-2.325h-2.541V4.725H21Z"
        clip-rule="evenodd"
    />
</svg>
